import { WebmotorsLoader } from '@/components/webmotors-loader';
import { SHARED_TEST_IDS } from '@/utils';

const AuthLoadingFallback = () => (
	<WebmotorsLoader overlay data-testid={SHARED_TEST_IDS.AUTH_LOADING_FALLBACK} />
);

AuthLoadingFallback.displayName = 'AuthLoadingFallback';

export { AuthLoadingFallback };
